import React, {useEffect} from 'react';
import CartHeader from './CartHeader';
import CartFooter, {isPromoCodeTextOk} from './CartFooter';
import CartOptionsPages from './CartOptionsPages';
import CartOptions from './CartOptions';
import CartOptionsNoPrice from './CartOptionsNoPrice';
import CartOptionsPerHour from './CartOptionsPerHour';
import CartOptionsAsap from './CartOptionsAsap';
import CartDiscount from './CartDiscount';
import CartTotal from './CartTotal';
import CartEta from './CartEta';
import { useSelector } from 'react-redux';
import { useCalcSelectors, useHeaderSize } from 'hooks';
import * as ProjectSelectors from 'store/project/projectSelectros';
import {isPromoCodeVisible} from "../Page/PageForm";

export  {isPromoCode};

let isPromoCode = false;
let promoCodeCoef = 0.5;

export default function Cart() {
  const {
    getTotalPricePages,
    getTotalPriceOptions,
    getTotalPrice,
    getDiscount,
    getEta,
    getTotalPriceForAsap
  } = useCalcSelectors();

    const [headerSize] = useHeaderSize();
  const projectTypeActive = useSelector(ProjectSelectors.selectProjectsTypeActive);
  const projectTypeActiveHash = useSelector(ProjectSelectors.selectProjectsTypeActiveHash);
  const projectKey = `${projectTypeActive}${projectTypeActiveHash}`;
  const payments = useSelector(ProjectSelectors.selectPayments);
  const checklist = useSelector(ProjectSelectors.selectChecklist);
  const optionsWithPrice = useSelector(ProjectSelectors.selectOptionsWithPrice);
  const optionsPagesIsExists = useSelector(ProjectSelectors.selectOptionsPagesIsExists);
  const optionsPages = useSelector(ProjectSelectors.selectOptionsPages);
  const optionsPagesTotal = useSelector(getTotalPricePages(projectKey));
  const optionsEmailSignature = useSelector(ProjectSelectors.selectOptionsEmailSignature);
  const options = useSelector(ProjectSelectors.selectOptionsRest);
  const optionAsap = useSelector(ProjectSelectors.selectOptionsAsap)[0];
  const optionsNoPrice = useSelector(ProjectSelectors.selectOptionsNoPrice);
  const optionsNoPriceIsExists = useSelector(ProjectSelectors.selectOptionsNoPriceIsExists);
  const optionsTotal = useSelector(getTotalPriceOptions(projectKey));
  const optionsPerHour = useSelector(ProjectSelectors.selectOptionsPerHour);
  const discount = useSelector(getDiscount(projectKey));
  const total = useSelector(getTotalPrice(projectKey));
  const eta = useSelector(getEta(projectKey));
  const pagesIsExists = optionsPagesIsExists && optionsPages.length > 0;
  const pagesIsNotExists = !optionsPagesIsExists && optionsPages.length === 0;
  const totalPriceForAsap = useSelector(getTotalPriceForAsap(projectKey));

  const projectDetails = useSelector(ProjectSelectors.selectProjectDetails);

  const CartComponents = () => {
    return (
      <>
        <CartOptionsPages options={optionsPages} optionsPagesTotal={optionsPagesTotal} projectTypeActive={projectTypeActive}/>
        <CartOptionsNoPrice options={optionsNoPrice}  pagesIsNotExists={pagesIsNotExists} optionsWithPrice={optionsWithPrice}/>
        <CartOptions options={optionsEmailSignature} optionsTotal={0} optionsPages={optionsPages}/>
        <CartOptions options={options} optionsTotal={optionsTotal} optionsPages={optionsPages} />
        <CartOptionsPerHour options={optionsPerHour} />
        <CartOptionsAsap optionAsap={optionAsap} totalPriceForAsap={totalPriceForAsap}/>
        <CartDiscount discount={discount}  optionsPagesTotal={optionsPagesTotal} />
        {/*<CartTotal total={total} />*/}
        <CartTotal total={(isPromoCode && isPromoCodeVisible) ? Math.floor(total * promoCodeCoef) : total} />
        <CartEta eta={eta} />
      </>
    );
  };

    useEffect(() => {
        isPromoCode = false;
    },[]);

  return (
    <div className="app-cart" style={{top: headerSize.height, position: 'sticky'}}>
      <CartHeader
        pagesIsExists={pagesIsExists}
        pagesIsNotExists={pagesIsNotExists}
        optionsWithPrice={optionsWithPrice}
        optionsNoPriceIsExists={optionsNoPriceIsExists}
      />
      {pagesIsExists && (<CartComponents />)}
      {pagesIsNotExists && (<CartComponents />)}
        {!projectDetails.isButtonOnTheLeft && (<CartFooter
        eta={eta}
        checklist={checklist}
        payments={payments}
        total={total}
        pagesIsNotExists={pagesIsNotExists}
        optionsWithPrice={optionsWithPrice}
        pagesIsExists={pagesIsExists}
        isButtonOnLeft={projectDetails.isButtonOnTheLeft}
        isCartPaymentsHidden={projectDetails.isCartPaymentsHidden}
      />)}
    </div>
  )
}
